export default __webpack_public_path__ + "static/media/sol_logo.0eb7266b.png";